(function () {
  const STORAGE_KEY = 'nw_reserve_submission_context';
  const STORAGE_VERSION = 1;

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function normalizeHandle(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function readProductContext() {
    const contextEl = document.getElementById('nw-reserve-product-context');
    if (!contextEl || !contextEl.textContent) return {};

    try {
      return JSON.parse(contextEl.textContent);
    } catch (error) {
      return {};
    }
  }

  function getCurrentProductHandle() {
    const match = window.location.pathname.match(/\/products\/([^/?#]+)/);
    return match && match[1] ? decodeURIComponent(match[1]) : '';
  }

  function getSelectedVariantText() {
    const selectedVariantSpan = document.querySelector('.nw-pdp-option__selected-val.value');
    const selectedText = selectedVariantSpan && selectedVariantSpan.innerText
      ? selectedVariantSpan.innerText.trim()
      : '';

    return selectedText && selectedText !== 'None' ? selectedText : '';
  }

  function getSelectedAddons() {
    const addonLines = document.querySelectorAll('.nw-pdp-addon-summary__line');
    return Array.from(addonLines)
      .map((line) => line.innerText.replace(/\n/g, ' ').trim())
      .filter(Boolean);
  }

  function buildCollectionHandles(collections) {
    if (!Array.isArray(collections)) return [];

    const handles = [];
    collections.forEach((collection) => {
      const handle = normalizeHandle(collection && collection.handle);
      if (!handle || handle === 'all' || handle === 'frontpage') return;
      if (!handles.includes(handle)) handles.push(handle);
    });

    return handles;
  }

  function buildSubmittedContext(btn, formId) {
    const productContext = readProductContext();
    const productTitle = productContext.title || document.querySelector('.nw-pdp-title')?.innerText?.trim() || '';
    const productHandle = productContext.handle || getCurrentProductHandle();
    const selectedVariant = getSelectedVariantText();
    const addons = getSelectedAddons();

    return {
      version: STORAGE_VERSION,
      savedAt: Date.now(),
      formId,
      sourcePath: window.location.pathname,
      productId: productContext.id || '',
      productHandle,
      productTitle,
      productUrl: productContext.url || (productHandle ? `/products/${productHandle}` : window.location.pathname),
      collectionHandles: buildCollectionHandles(productContext.collections),
      tags: Array.isArray(productContext.tags) ? productContext.tags : [],
      selectedVariant,
      addons,
      buttonText: btn ? btn.textContent.trim() : '',
    };
  }

  function persistSubmittedContext(context) {
    if (!context || !context.productTitle) return;

    try {
      window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(context));
    } catch (error) {
      window.nwReserveSubmissionContext = context;
    }
  }

  function buildHiddenFieldValue(context) {
    const parts = [context.productTitle || ''];

    if (context.selectedVariant) {
      parts.push(`Variant: ${context.selectedVariant}`);
    }

    if (Array.isArray(context.addons) && context.addons.length > 0) {
      parts.push(`Add-ons: ${context.addons.join(', ')}`);
    }

    return parts.filter(Boolean).join(' | ');
  }

  function buildSelectedHtml(context) {
    let selectedHtml = `<strong>${escapeHtml(context.productTitle || 'Selected product')}</strong>`;

    if (context.selectedVariant) {
      selectedHtml += `<br>Variant: ${escapeHtml(context.selectedVariant)}`;
    }

    if (Array.isArray(context.addons) && context.addons.length > 0) {
      selectedHtml += '<br>Add-ons:<br>';
      selectedHtml += context.addons
        .map((addon) => `<span style="padding-left: 10px;">- ${escapeHtml(addon)}</span>`)
        .join('<br>');
    }

    return selectedHtml;
  }

  function revealInlineForm(formId) {
    const inlineForm = document.querySelector(`[data-nw-klaviyo-inline-form="${formId}"]`);
    if (!inlineForm) return false;

    inlineForm.hidden = false;
    inlineForm.setAttribute('aria-hidden', 'false');
    inlineForm.classList.add('is-visible');
    inlineForm.scrollIntoView({ behavior: 'smooth', block: 'center' });

    return true;
  }

  function findProductRequestedField(klaviyoForm) {
    if (!klaviyoForm) return null;

    const directMatch = klaviyoForm.querySelector('input[id^="requested_product_"]')
      || klaviyoForm.querySelector('textarea[id^="requested_product_"]')
      || klaviyoForm.querySelector('input[placeholder*="Product"]')
      || klaviyoForm.querySelector('textarea[placeholder*="Product"]')
      || klaviyoForm.querySelector('input[placeholder*="Order"]');

    if (directMatch) return directMatch;

    const fields = klaviyoForm.querySelectorAll('input, textarea');
    return Array.from(fields).find(function (field) {
      const haystack = [
        field.id,
        field.name,
        field.placeholder,
        field.getAttribute('aria-label'),
      ].join(' ').toLowerCase();

      return haystack.includes('product requested')
        || haystack.includes('requested product')
        || haystack.includes('product_requested')
        || haystack.includes('requested_product');
    }) || null;
  }

  window.handleKlaviyoTriggerClick = function (btn) {
    const formId = btn && typeof btn.getAttribute === 'function'
      ? btn.getAttribute('data-klaviyo-form-id') || 'Y8kvmz'
      : 'Y8kvmz';
    const submittedContext = buildSubmittedContext(btn, formId);
    const hiddenFieldValue = buildHiddenFieldValue(submittedContext);
    const selectedHtml = buildSelectedHtml(submittedContext);

    persistSubmittedContext(submittedContext);

    revealInlineForm(formId);
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', formId]);

    let attempts = 0;
    const interval = setInterval(function () {
      attempts++;

      const klaviyoForm = document.querySelector(`form[data-testid="klaviyo-form-${formId}"]`);
      if (!klaviyoForm) {
        if (attempts > 60) {
          clearInterval(interval);
        }
        return;
      }

      const productField = findProductRequestedField(klaviyoForm);

      if (productField) {
        productField.value = hiddenFieldValue;
        productField.dispatchEvent(new Event('input', { bubbles: true }));
        productField.dispatchEvent(new Event('change', { bubbles: true }));

        const fieldWrapper = productField.closest('[data-testid="form-component"]');
        if (fieldWrapper) fieldWrapper.style.display = 'none';
      }

      let display = klaviyoForm.querySelector('.preorder-product-display');
      if (!display) {
        display = document.createElement('div');
        display.className = 'preorder-product-display';
        display.style.margin = '10px 0 20px';
        display.style.padding = '14px';
        display.style.backgroundColor = '#f7f6f1';
        display.style.border = '1px solid #DFDCD7';
        display.style.borderRadius = '8px';
        display.style.fontSize = '14px';
        display.style.color = '#333';
        display.style.lineHeight = '1.4';

        const heading = klaviyoForm.querySelector('h1, h2, h3, h4, h5, h6');
        if (heading) {
          heading.insertAdjacentElement('afterend', display);
        } else {
          klaviyoForm.insertAdjacentElement('afterbegin', display);
        }
      }

      const label = formId === 'VBBE2y' || formId === 'SFGAqc' ? 'Reservation Details' : 'Pre-Order Details';
      display.innerHTML = `<span style="display:block;margin-bottom:8px;font-size:12px;font-weight:600;text-transform:uppercase;color:#888;">${label}</span>${selectedHtml}`;

      clearInterval(interval);
    }, 150);
  };

  document.addEventListener('DOMContentLoaded', function () {
    document.body.addEventListener('click', function (e) {
      const btn = e.target.closest('.klaviyo_form_trigger');
      if (!btn) return;

      e.preventDefault();
      window.handleKlaviyoTriggerClick(btn);
    });
  });
})();
